<template>
  <div class="experiment-module">
    <b-row class="d-flex justify-content-between" v-if="rerender">
      <b-col lg="5" md="5" class="content-section">
        <div class="content-wrapper"  v-if="experimentDetails">
          <h1 class="experiment-title font-weight-bold mb-1 text-light">{{ experimentDetails.name }}</h1>

          <h5 class="experiment-subtitle mb-2 text-light">{{ experimentDetails.category_name }}</h5>

          <p class="experiment-description mb-2 text-light">{{ experimentDetails.description }}</p>
          <!-- <p class="experiment-description mb-2 text-light fs-5 fs-lg-4">{{ experimentDetails.description }}</p> -->

          <div class="progress-section mb-2">
            <label class="mb-50 font-weight-normal text-light">Progress</label>
            <div class="progress-wrapper">
              <b-progress
                :value="experiment.progress"
                :max="100"
                height="20px"
                class="custom-progress"
              ></b-progress>
              <div
                class="progress-indicator"
                :style="{ left: `calc(${experiment.progress}% - 20px)` }"
              ></div>
            </div>
          </div>

          <b-button variant="secondary" size="lg" class="run-button" @click.stop="openExperiment(experimentDetails.targetPackage)">
            <b-img src="/experiments/play.png" alt="Run" class="mr-2" />Run
          </b-button>
          
        </div>
      </b-col>

      <b-col lg="6" md="6" class="image-section">
        <div class="image-gallery">
          <div class="main-image-container">
            <b-img
              :src="`${experimentDetails.image}`"
              fluid
              alt="Main experiment image"
              class="main-image rounded mr-1"
            />
          </div>

          <div class="thumbnail-column d-flex flex-column justify-content-center">
            <div
              v-for="(thumbnail, index) in experiment.thumbnails"
              :key="index"
              class="thumbnail-container mb-2"
            >
              <b-img :src="thumbnail" fluid alt="Thumbnail" class="thumbnail-image rounded" />
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <div class="recommendation-section mt-5">
      <h4 class="mb-2 font-weight-bold text-white">You Might Also Like</h4>
      <b-row>
        <b-col v-for="(item, index) in recommendations" :key="index" cols="12" md="4" class="mb-3">
          <b-card class="rec-card">
            <b-row no-gutters align-h="between" align-v="center">
              <b-col cols="5" class="text-section pr-1">
                <h5 class="rec-title font-weight-bold text-white mb-1">{{ item.title }}</h5>
                <p class="rec-subtitle text-white-50 mb-0">{{ item.category }}</p>
              </b-col>

              <b-col cols="7">
                <b-img
                  :src="item.image"
                  alt="Recommendation Image"
                  class="rec-image rounded"
                  fluid
                />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  BRow,
  BCol,
  BProgress,
  BCard,
  BButton,
  BIcon,
  BImg
} from "bootstrap-vue";

export default {
  name: "ConcreteExperimentPage",
  components: {
    BRow,
    BCol,
    BProgress,
    BButton,
    BIcon,
    BImg,
    BCard
  },
  computed:{
    ...mapGetters({
      experimentDetails: "experiments/item",
      load: "experiments/load",
    }),
    id(){
      return this.$route.params.id ? this.$route.params.id : null
    },
    rerender(){
      this.init()
      return true
    }
  },
  data() {
    return {
      experiment: {
        name: "Concrete",
        specialization: "Civil Engineering",
        description:
          "This experience places learners in a virtual concrete construction site to apply core civil engineering skills using a digital building plan and a virtual measuring tool. Users answer a series of questions by evaluating structural elements such as beam placement and spacing. The experience focuses on practical application in site assessment and plan interpretation.",
        progress: 65,
        thumbnails: [
          "https://images.unsplash.com/photo-1504307651254-35680f356dfd?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
          "https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
          "https://images.unsplash.com/photo-1628744448840-55bdb2497bd4?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80"
        ]
      },
      recommendations: [
        {
          title: "HVAC",
          category: "Mechanical Engineering",
          image:
            require("../../../../assets/images/skeleton/2.png")
        },
        {
          title: "Steel",
          category: "Civil Engineering",
          image:
            require("../../../../assets/images/skeleton/3.png")
        },
        {
          title: "Bridge Load",
          category: "Civil Engineering",
          image:
            require("../../../../assets/images/skeleton/6.png")

        }
      ]
    };
  },
  methods:{
    init(){
      this.$store.dispatch('experiments/get', this.id).then(response=>{
      })
    },
    openExperiment(id){
      if (id) {
          console.log('================================ >>>.', id);
            setTimeout(function() {
                window.vuplex.postMessage(id);
            }, 3);
        } else {
            console.log("No ID provided in the URL.");
        }
    },
  },
  mounted() {
    // window.open("pageB.html?v=" + Date.now(), "_self");
    //  if (!sessionStorage.getItem('hasReloaded')) {
    //   sessionStorage.setItem('hasReloaded', 'true');
    //   window.location.href = window.location.href + `?v=${Date.now()}`;
    // }
    this.init()
  }
};
</script>
<style lang="scss" scoped>

.experiment-module {
  padding: 2rem 1rem;
  animation: fadeIn 1s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .content-wrapper {
    max-width: 100%;
    animation: slideInLeft 1s ease forwards;
    color: #e9ecef;
    @keyframes slideInLeft {
      from {
        opacity: 0;
        transform: translateX(-30px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }
  }
  .progress-section {
    .progress-wrapper {
      position: relative;
      width: 80%;
    }

    .custom-progress {
      background-color: transparent !important;
      border-radius: 8px;
      box-shadow: inset 0 2px 20px rgba(0, 0, 0, 0.4);
      transition: width 0.5s ease;

      ::v-deep .progress-bar {
        border-radius: 8px;
        background-color: #ffffffba !important;
      }
    }

    .progress-indicator {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 20px;
      height: 20px;
      background-color: white;
      border-radius: 50%;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.4);
      pointer-events: none;
    }
  }

  .run-button {
    background: rgba(255, 255, 255, 0.182) !important;
    color: white !important;
    padding: 3px 17px 3px 4px;
    font-weight: 600;
    font-size: 1.1rem;
    display: flex;
    align-items: center;
    transition: all 0.3s ease, box-shadow 0.3s ease;
    animation: slideInUp 1s ease forwards;
    border: 2px solid #ffffff2e !important;
    border-left: none !important;
    border-right: none !important;
    border-radius: 50px;

    @keyframes slideInUp {
      from {
        opacity: 0;
        transform: translateY(30px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    &:hover {
      transform: translateY(-2px) scale(1.05);
      background: #a6a7aa !important;
      box-shadow: 0 6px 20px rgba(166, 167, 170, 0.4);
    }
  }

  .run-button:hover {
    background-color: rgba(233, 236, 239, 0.693) !important;
  }

  .image-gallery {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
    animation: fadeIn 1.2s ease-in-out;

    .main-image-container {
      width: 100%;
      max-width: 355px;

      .main-image {
        width: 100%;
        height: auto;
        min-height: 300px;
        object-fit: cover;
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
        transition: transform 0.4s ease;

        &:hover {
          transform: scale(1.03);
        }
      }
    }

    .thumbnail-column {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      .thumbnail-container {
        width: 70px;
        height: 75px;
        overflow: hidden;

        .thumbnail-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          cursor: pointer;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

          &:hover {
            transform: scale(1.1);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          }
        }
      }
    }
  }

  .recommendation-section {
    width: 90%;
    margin-top: 3rem;

    .rec-card {
      background: rgba(255, 255, 255, 0.05);
      border-radius: 12px;
      border: none;
      cursor: pointer;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
      animation: fadeIn 1.5s ease-in-out;

      &:hover {
        transform: translateY(-5px) scale(1.03);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
      }
    }
  }

  @media (max-width: 991px) {
    .image-gallery {
      justify-content: center;
      flex-direction: column;
      align-items: center;

      .thumbnail-column {
        flex-direction: row !important;
        justify-content: center;
        flex-wrap: wrap;

        .thumbnail-container {
          width: 60px;
          height: 60px;
        }
      }
    }

    .custom-progress {
      width: 100%;
    }

    .run-button {
      justify-content: center;
      width: 100%;
      padding: 0.5rem 1rem;
      margin-bottom: 3rem;
    }
  }

  @media (max-width: 576px) {
    .experiment-title {
      font-size: 1.75rem;
    }

    .experiment-subtitle {
      font-size: 1rem;
    }

    .experiment-description {
      font-size: 0.9rem;
    }

    .thumbnail-column {
      .thumbnail-container {
        width: 50px;
        height: 50px;
      }
    }

    .rec-card {
      .rec-title {
        font-size: 1rem;
      }

      .rec-subtitle {
        font-size: 0.85rem;
      }
    }
  }
}

.rec-image{
  max-width: 100px;
  float: right;
}

</style>